import React from 'react';
import { BookOpenIcon, BrainIcon, LeafIcon, CheckCircle2Icon } from 'lucide-react';
const StatsWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-1286">
      <div className="p-4" data-id="element-1287">
        <h2 className="text-base font-semibold text-gray-800 mb-4" data-id="element-1288">
          Statistiche Studio
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1289">
          <StatCard icon={<LeafIcon className="text-gray-600" size={20} strokeWidth={1.5} data-id="element-1291" />} label="Azioni Sostenibili" value="142" trend="+12 questa settimana" trendUp={true} data-id="element-1290" />
          <StatCard icon={<BookOpenIcon className="text-gray-600" size={20} strokeWidth={1.5} data-id="element-1293" />} label="Lezioni Completate" value="28" trend="su 3 corsi attivi" data-id="element-1292" />
          <StatCard icon={<CheckCircle2Icon className="text-gray-600" size={20} strokeWidth={1.5} data-id="element-1295" />} label="Attività Completate" value="45" trend="Lezioni, quiz ed esercizi" trendUp={true} data-id="element-1294" />
          <StatCard icon={<BrainIcon className="text-gray-600" size={20} strokeWidth={1.5} data-id="element-1297" />} label="Streak di Studio" value="5" trend="giorni consecutivi" trendUp={true} data-id="element-1296" />
        </div>
      </div>
    </div>;
};
interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  trend: string;
  trendUp?: boolean;
}
const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  trend,
  trendUp
}) => {
  return <div className="p-3 border border-gray-200 rounded-lg" data-id="element-1298">
      <div className="flex items-center space-x-2 mb-2" data-id="element-1299">
        {icon}
        <div className="text-lg font-medium text-gray-800" data-id="element-1300">{value}</div>
      </div>
      <div className="text-sm text-gray-600 font-normal" data-id="element-1301">{label}</div>
      <div className={`text-xs ${trendUp ? 'text-green-600' : 'text-gray-500'} mt-1 font-normal`} data-id="element-1302">
        {trend}
      </div>
    </div>;
};
export default StatsWidget;